import visa from '../assetsx/optimized/visax.webp';
import apple from '../assetsx/optimized/applepay.webp';
import bestbuy from '../assetsx/optimized/bestbuy.webp';
import ebay from '../assetsx/optimized/ebay.webp';
import googleplay from '../assetsx/optimized/googleplay.webp';
import itunes from '../assetsx/optimized/itunesall.webp';
import netflix from '../assetsx/optimized/netflix.webp';
import sephora from '../assetsx/optimized/sephora.webp';
import starbucks from '../assetsx/optimized/starbucks.webp';
import walmart from '../assetsx/optimized/walmart.webp';
import allgiftcards from '../assetsx/optimized/allgiftcards.webp';
import appstore from '../assetsx/appstore.png';

const giftCardImages = [
  { name: 'Visa', url: visa },
  { name: 'Apple', url: apple },
  { name: 'Best Buy', url: bestbuy },
  { name: 'eBay', url: ebay },
  { name: 'Google Play', url: googleplay },
  { name: 'iTunes', url: itunes },
  { name: 'Netflix', url: netflix },
  { name: 'Sephora', url: sephora },
  { name: 'Starbucks', url: starbucks },
  { name: 'Walmart', url: walmart },
  { name: 'Allgiftcards', url: allgiftcards },
  { name: 'App Store', url: appstore },
];

export default giftCardImages;
